import { Pipe, PipeTransform } from '@angular/core';
import { includes as _includes } from 'lodash-es';

@Pipe({
  name: 'includes'
})
export class IncludesPipe implements PipeTransform {

  transform(value: string, array: string[]): unknown {
    return _includes(array, value);
  }

}
